var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppPageCard',{scopedSlots:_vm._u([{key:"card-title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("SCHOOLDETAILS.MESSAGE.SCHOOLDETAILS"))+" ")]},proxy:true}])},[_c('SchoolInfoForm',{attrs:{"initial-form":_vm.info},on:{"onSubmitClick":_vm.submitForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }